module.exports = __webpack_public_path__ + "9fe816505a432695a40c731639c6cee0.svg";